<div *ngFor="let message of messages$ | async">
	<div class="timestamp">{{message.timestamp | date : 'medium'}}</div>
	<div class="user">{{message.user}}</div>
	<div class="text">{{message.text}}</div>
	<workflow-query-state *ngIf="message.state" [state]="message.state"></workflow-query-state>
</div>